import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Box1 from './components/Box1';
import Box2 from './components/Box2';
import Box3 from './components/Box3';
import Box4 from './components/Box4';
import Box5 from './components/Box5';
import Box6 from './components/Box6';
import Box7 from './components/Box7';
import Box8 from './components/Box8';
import Box9 from './components/Box9';
import request from '@/request/request';
const Dashboard = () => {
  // const [scale, setScale] = useState(1);

  // const handleResize = () => {
  //   const scaleWidth = window.innerWidth / 1920;
  //   const scaleHeight = window.innerHeight / 1080;
  //   // 等比缩放取最小值，防止跑版
  //   setScale(Math.min(scaleWidth, scaleHeight));
  // };

  // useEffect(() => {
  //   handleResize();
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);
  const [loading, setLoading] = useState(false);
  const [charts, setCharts] = useState({});
  const fetchData = async () => {
    setLoading(true);
    const response = await request(
      '/idcService/agency/archivesReport/summary/charts/v2',
      {
        method: 'GET',
        data: {},
      }
    );
    const payload = response.data;
    setCharts(payload.charts ?? {});
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div
      style={{
        background: 'rgb(20, 20, 26)',
        // transform: `scale(${scale})`,
      }}
    >
      <div
        style={{
          height: '8vh',
          background:
            'linear-gradient(0deg, rgb(21, 35, 48) 2%, rgb(17, 26, 40) 100%)',
        }}
      >
        <Header />
      </div>
      <div
        style={{
          height: '92vh',
          display: 'flex',
          flexDirection: 'row',
          padding: '5px 5px 10px 5px',
          boxSizing: 'border-box',
          gap: '5px',
        }}
      >
        <div
          style={{
            width: '20vw',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
          }}
        >
          {/* 建档概览，高22vh */}
          <Box1 charts={charts} />
          {/* 人群分布情况，高35vh */}
          <Box2 charts={charts} />
          {/* 人群风险等级情况，高35vh */}
          <Box3 charts={charts} />
        </div>
        <div
          style={{
            width: '25vw',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
          }}
        >
          {/* 建档概览，高22vh */}
          <Box4 charts={charts} />
          {/* 人群分布情况，高35vh */}
          <Box5 charts={charts} />
        </div>
        <div
          style={{
            width: '30vw',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
          }}
        >
          {/* 建档概览，高22vh */}
          <Box6 charts={charts} />
          {/* 人群分布情况，高35vh */}
          <Box7 charts={charts} />
        </div>
        <div
          style={{
            width: '25vw',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
          }}
        >
          {/* 建档概览，高22vh */}
          <Box8 charts={charts} />
          {/* 人群分布情况，高35vh */}
          <Box9 charts={charts} />
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
